// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-color-palette {
  display: flex;
  flex-direction: column;
  padding: var(--g-spacing-4);
}
.dl-color-palette__hint {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
  color: var(--g-color-text-secondary);
  margin-top: var(--g-spacing-2);
}
.dl-color-palette__custom-palette-bg-btn, .dl-color-palette__highlight-wrapper {
  width: 28px;
  height: 28px;
}
.dl-color-palette__custom-palette-bg-btn, .dl-color-palette__palette-list-btn {
  --g-button-border-radius: 6px;
  --g-button-background-color: transparent;
  --g-button-background-color-hover: transparent;
}
.dl-color-palette__preset {
  display: grid;
  grid-template-columns: repeat(auto-fit, 28px);
  margin-block-end: var(--g-spacing-2);
  gap: var(--g-spacing-2);
  flex-shrink: 0;
}
.dl-color-palette__palette {
  margin-block-start: var(--g-spacing-5);
  flex-shrink: 0;
}
.dl-color-palette__color-picker {
  display: block;
  width: 140px;
  min-width: 100%;
  flex-shrink: 0;
}
.dl-color-palette__highlight-wrapper {
  --_--color-item-border-color: transparent;
  position: relative;
  border-radius: 6px;
}
.dl-color-palette__highlight-wrapper_with-border {
  --_--color-item-border-color: var(--g-color-line-generic);
}
.dl-color-palette__highlight-wrapper_with-border .dl-color-palette__color-item {
  border: 1px solid var(--g-color-line-generic);
}
.dl-color-palette__highlight-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  border: 1px solid var(--_--color-item-border-color);
  border-radius: 6px;
}
.dl-color-palette__highlight-wrapper_selected, .dl-color-palette__highlight-wrapper:hover {
  --_--color-item-border-color: transparent;
}
.dl-color-palette__highlight-wrapper_selected .dl-color-palette__color-item, .dl-color-palette__highlight-wrapper:hover .dl-color-palette__color-item {
  border-width: 0px;
}
.dl-color-palette__highlight-wrapper:not(.dl-color-palette__highlight-wrapper_selected):hover::before {
  content: "";
  position: absolute;
  inset: -3px;
  border: 2px solid var(--g-color-line-generic-hover);
  border-radius: 9px;
}
.dl-color-palette__highlight-wrapper_selected::before {
  content: "";
  position: absolute;
  inset: -3px;
  border: 2px solid var(--g-color-line-brand);
  border-radius: 9px;
}
.dl-color-palette__tooltip-trigger {
  position: absolute;
  inset: 0;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/dash/containers/Dialogs/components/ColorPalette/ColorPalette.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAKI,aAAA;EACA,sBAAA;EAEA,2BAAA;AANJ;AAQI;EC2JA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ED5JI,oCAAA;EACA,8BAAA;AAHR;AAMI;EAEI,WAjBc;EAkBd,YAlBc;AAatB;AAQI;EAGI,6BAAA;EAEA,wCAAA;EACA,8CAAA;AATR;AAYI;EACI,aAAA;EACA,6CAAA;EACA,oCAAA;EACA,uBAAA;EACA,cAAA;AAVR;AAaI;EACI,sCAAA;EACA,cAAA;AAXR;AAcI;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAZR;AAeI;EACI,yCAAA;EACA,kBAAA;EAEA,kBAAA;AAdR;AAgBQ;EACI,yDAAA;AAdZ;AAgBY;EACI,6CAAA;AAdhB;AAkBQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mDAAA;EACA,kBAAA;AAhBZ;AAmBQ;EAEI,yCAAA;AAlBZ;AAmBY;EACI,iBAAA;AAjBhB;AAqBQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mDAAA;EACA,kBAAA;AAnBZ;AAsBQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,kBAAA;AApBZ;AAwBI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;AAtBR","sourcesContent":[".dl-color-palette {\n  display: flex;\n  flex-direction: column;\n  padding: var(--g-spacing-4);\n}\n.dl-color-palette__hint {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n  color: var(--g-color-text-secondary);\n  margin-top: var(--g-spacing-2);\n}\n.dl-color-palette__custom-palette-bg-btn, .dl-color-palette__highlight-wrapper {\n  width: 28px;\n  height: 28px;\n}\n.dl-color-palette__custom-palette-bg-btn, .dl-color-palette__palette-list-btn {\n  --g-button-border-radius: 6px;\n  --g-button-background-color: transparent;\n  --g-button-background-color-hover: transparent;\n}\n.dl-color-palette__preset {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 28px);\n  margin-block-end: var(--g-spacing-2);\n  gap: var(--g-spacing-2);\n  flex-shrink: 0;\n}\n.dl-color-palette__palette {\n  margin-block-start: var(--g-spacing-5);\n  flex-shrink: 0;\n}\n.dl-color-palette__color-picker {\n  display: block;\n  width: 140px;\n  min-width: 100%;\n  flex-shrink: 0;\n}\n.dl-color-palette__highlight-wrapper {\n  --_--color-item-border-color: transparent;\n  position: relative;\n  border-radius: 6px;\n}\n.dl-color-palette__highlight-wrapper_with-border {\n  --_--color-item-border-color: var(--g-color-line-generic);\n}\n.dl-color-palette__highlight-wrapper_with-border .dl-color-palette__color-item {\n  border: 1px solid var(--g-color-line-generic);\n}\n.dl-color-palette__highlight-wrapper::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border: 1px solid var(--_--color-item-border-color);\n  border-radius: 6px;\n}\n.dl-color-palette__highlight-wrapper_selected, .dl-color-palette__highlight-wrapper:hover {\n  --_--color-item-border-color: transparent;\n}\n.dl-color-palette__highlight-wrapper_selected .dl-color-palette__color-item, .dl-color-palette__highlight-wrapper:hover .dl-color-palette__color-item {\n  border-width: 0px;\n}\n.dl-color-palette__highlight-wrapper:not(.dl-color-palette__highlight-wrapper_selected):hover::before {\n  content: \"\";\n  position: absolute;\n  inset: -3px;\n  border: 2px solid var(--g-color-line-generic-hover);\n  border-radius: 9px;\n}\n.dl-color-palette__highlight-wrapper_selected::before {\n  content: \"\";\n  position: absolute;\n  inset: -3px;\n  border: 2px solid var(--g-color-line-brand);\n  border-radius: 9px;\n}\n.dl-color-palette__tooltip-trigger {\n  position: absolute;\n  inset: 0;\n  z-index: 1000;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
